import { useEffect } from 'react'

import { ClampingTextContentNodeClamp } from '../../ClampingTextContentNodeClamp'
import { useClampingTextMeasure } from '../useClampingTextMeasure'

export function useClampingText({
  clamped,
  clampingLinesCount,
  fullText,
  setShowExpandButton,
  textClassName,
  truncationSymbol,
  ...clampingConfig
}) {
  const {
    content,
    isTruncated,
    measureRef,
    measureTailRef,
    measureTextRef,
    rootRef,
  } = useClampingTextMeasure({ clampingLinesCount, fullText, truncationSymbol })

  useEffect(() => {
    setShowExpandButton(isTruncated)
  }, [isTruncated, setShowExpandButton])

  return {
    text: (
      <ClampingTextContentNodeClamp
        {...clampingConfig}
        clamped={clamped}
        content={content}
        fullText={fullText}
        measureRef={measureRef}
        rootRef={rootRef}
        tailRef={measureTailRef}
        textClassName={textClassName}
        textRef={measureTextRef}
      />
    ),
  }
}
